import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const pagination = getProductListDataViewProperty(state, "pagination");
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");
    const { productFilters } = state.pages.productList;

    return {
        totalItemCount: pagination?.totalItemCount,
        query: correctedQuery || productFilters.query,
        view: state.pages.productList.view,
    };
};

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

export interface ProductListControlsContainerStyles {
    container?: GridContainerProps;
    countProductListViewGridItem?: GridItemProps;
    sortByProductListViewGridItem?: GridItemProps;
    viewProductListViewGridItem?: GridItemProps;
    viewCardViewGridItem?: GridItemProps;
    noReasultFound?: InjectableCss;
}

export const controlsContainerStyles: ProductListControlsContainerStyles = {
    container: {
        gap: 0,
        css: css`
            border-bottom: none;
            padding: 0;
            padding: 0em 2em 0em 2em;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0em 0.75em 0em 0.75em;
                    `,
                    css`
                        padding: 0em 0.75em 0em 0.75em;
                    `,
                    css`
                        
                    `,
                    css`
                        
                    `,
                    css`
                        
                    `,
            ])}
        `
    },
    countProductListViewGridItem: {
        width: [12, 12, 12, 12, 12],
    },
    sortByProductListViewGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            margin: 16px 0 !important;
        `
    },
    viewProductListViewGridItem:{
        width: [12, 12, 8, 8, 8],
        css: css `
            display: flex;
            justify-content: start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        
                    `,
                    css`
                
                    `,
                    css`
                    `,
                    css`
                    `,
                    css`
                    `,
            ])}
        `
    },
    viewCardViewGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                    display: none;
                    `,
                    css`
                    `,
                    css`
                    `,
                    css`
                    `,
            ])}
        `
    },
    noReasultFound:{
        css: css`
            font-family: Franklin Gothic Demi;
            font-size: 15px;
            padding: 30px 2em 10px 2em;
        `
    }
};

const styles = controlsContainerStyles;

const ProductListControlsContainer: FC<Props> = ({ id, view , totalItemCount, query}) => {
 
    if( totalItemCount === 0 && query){
    return <>
    <Typography {...styles.noReasultFound} >No results found for: {query}</Typography>
    </>
   }
    return (
        <>
            {totalItemCount !== 0 &&
                <GridContainer {...styles.container}>
                <GridItem {...styles.countProductListViewGridItem}>
                    <Zone contentId={id} zoneName="Content01" />
                </GridItem>
                <GridItem {...styles.sortByProductListViewGridItem}>
                    <Zone contentId={id} zoneName="Content02" />
                </GridItem>
                <GridItem {...styles.viewProductListViewGridItem}>
                    <Zone contentId={id} zoneName="Content03" />
                </GridItem>
                <GridItem {...styles.viewCardViewGridItem}>
                    <Zone contentId={id} zoneName="Content04" />
                </GridItem>
            </GridContainer>  
            }
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListControlsContainer),
    definition: {
        group: "Product List",
        displayName: "List Controls Container",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
